{
  "version": 1,
  "asset_id": "fd6394ce-4228-430e-a981-4b6001fd4b2d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/fd6394ce-4228-430e-a981-4b6001fd4b2d/wordmark-900.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/fd6394ce-4228-430e-a981-4b6001fd4b2d/wordmark-900.avif",
  "original_filename": "wordmark-900.avif",
  "size": 16157,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:19:22Z"
}
